
<form (submit)="onSave(noteForm)" #noteForm="ngForm"  class="p-5">
  <div class="w-full mb-4 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600">
    <div class="px-4 py-2 bg-white rounded-t-lg dark:bg-gray-800">
      <label for="testo" class="sr-only">Your comment</label>
      <textarea [(ngModel)]="testo" name="testo" rows="15" class="w-full text-4xl px-0 text-gray-900 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400" placeholder="Scrivi qui le note giornaliere..." >
        {{ testo }}
      </textarea>
    </div>
    <div class="flex items-center justify-between px-3 py-2 border-t dark:border-gray-600">
      <button type="submit" class="inline-flex items-center py-2.5 px-4 text-xs font-medium text-center text-white bg-blue-700 rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800">
        Salva note
      </button>
    </div>
  </div>
</form>
